"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResponsiveData = exports.useResponsiveStyle = exports.useDynamicResponsiveValue = exports.getResponsiveRule = exports.ResponsiveViewport = exports.ResponsiveContext = exports.getResponsiveLayout = void 0;
var react_1 = __importStar(require("react"));
var react_native_1 = require("react-native");
var getResponsiveLayout = function (props) {
    var responsiveLayout = props.responsiveLayout, xs = props.xs, sm = props.sm, md = props.md, lg = props.lg, xl = props.xl, xxl = props.xxl, xxxl = props.xxxl;
    if (!!responsiveLayout)
        return responsiveLayout;
    var shortObj = { xs: xs, sm: sm, md: md, lg: lg, xl: xl, xxl: xxl, xxxl: xxxl };
    if (typeof shortObj.xs === 'undefined')
        delete shortObj.xs;
    if (typeof shortObj.sm === 'undefined')
        delete shortObj.sm;
    if (typeof shortObj.md === 'undefined')
        delete shortObj.md;
    if (typeof shortObj.lg === 'undefined')
        delete shortObj.lg;
    if (typeof shortObj.xl === 'undefined')
        delete shortObj.xl;
    if (typeof shortObj.xxl === 'undefined')
        delete shortObj.xxl;
    if (typeof shortObj.xxxl === 'undefined')
        delete shortObj.xxxl;
    return Object.keys(shortObj).length > 0 ? shortObj : undefined;
};
exports.getResponsiveLayout = getResponsiveLayout;
exports.ResponsiveContext = react_1.createContext({
    width: react_native_1.Dimensions.get('window').width,
    useCustomViewport: false,
});
var ResponsiveViewport = function (_a) {
    var width = _a.width, children = _a.children;
    return (react_1.default.createElement(exports.ResponsiveContext.Provider, { value: { width: width, useCustomViewport: true } }, children));
};
exports.ResponsiveViewport = ResponsiveViewport;
var getResponsiveRule = function (viewportWidth, rules) {
    var minWidthBreakpoints = {
        xs: 0,
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1200,
        xxl: 1380,
        xxxl: 1560,
    };
    for (var customBreakpoint in rules) {
        if (typeof minWidthBreakpoints[customBreakpoint] === 'number')
            continue;
        if (!customBreakpoint.includes('px'))
            continue;
        var breakpointWidth = +customBreakpoint.replace('px', '');
        if (isNaN(breakpointWidth))
            continue;
        minWidthBreakpoints[customBreakpoint] = breakpointWidth;
    }
    var breakpoints = Object.keys(minWidthBreakpoints).sort(function (a, b) {
        var widthA = minWidthBreakpoints[a];
        if (typeof widthA !== 'number')
            return 1;
        var widthB = minWidthBreakpoints[b];
        if (typeof widthB !== 'number')
            return 1;
        return widthA > widthB ? -1 : 1;
    });
    var currentBreakpoint = 'xs';
    for (var i = 0; i <= breakpoints.length; i++) {
        var breakpointCode = breakpoints[i];
        var compareWidth = minWidthBreakpoints[breakpointCode];
        if (typeof compareWidth !== 'number')
            continue;
        if (viewportWidth >= compareWidth) {
            currentBreakpoint = breakpointCode;
            if (!rules[breakpointCode])
                continue;
            break;
        }
    }
    var responsiveRule = rules[currentBreakpoint];
    return responsiveRule;
};
exports.getResponsiveRule = getResponsiveRule;
var useDynamicResponsiveValue = function () {
    var order = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl', 'xxxl'];
    var breakpoint = exports.useResponsiveStyle({
        xs: 'xs',
        sm: 'sm',
        md: 'md',
        lg: 'lg',
        xl: 'xl',
        xxl: 'xxl',
        xxxl: 'xxxl',
    });
    return function (dynamicObj) {
        var orderIndex = order.indexOf(breakpoint);
        for (var i = orderIndex; i >= 0; i--) {
            if (order[i] in dynamicObj) {
                return dynamicObj[order[i]];
            }
        }
        return undefined;
    };
};
exports.useDynamicResponsiveValue = useDynamicResponsiveValue;
var useResponsiveStyle = function (onResponsiveStyle) {
    if (!onResponsiveStyle)
        return undefined;
    var width = react_native_1.useWindowDimensions().width;
    var _a = react_1.useContext(exports.ResponsiveContext), customWidth = _a.width, useCustomViewport = _a.useCustomViewport;
    var viewportWidth = useCustomViewport ? customWidth : width;
    var responsiveRule = exports.getResponsiveRule(viewportWidth, onResponsiveStyle);
    return responsiveRule;
};
exports.useResponsiveStyle = useResponsiveStyle;
function useResponsiveData(rules) {
    if (!rules)
        return undefined;
    var width = react_native_1.useWindowDimensions().width;
    var _a = react_1.useContext(exports.ResponsiveContext), customWidth = _a.width, useCustomViewport = _a.useCustomViewport;
    var viewportWidth = useCustomViewport ? customWidth : width;
    var responsiveRule = exports.getResponsiveRule(viewportWidth, rules);
    return responsiveRule;
}
exports.useResponsiveData = useResponsiveData;
;
//# sourceMappingURL=useResponsiveStyle.js.map